import React from 'react';
import '../../fonts.css';
import './BlackSection.css';
import { motion, Variants } from 'framer-motion';

const BlackSection: React.FC = () => {
  const scrollToPortfolio = () => {
    const portfolioSection = document.getElementById('portfolio');
    if (portfolioSection) {
      portfolioSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToWhiteSection = () => {
    const whiteSection = document.getElementById('about');
    if (whiteSection) {
      whiteSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.15,
        delayChildren: 0.3
      }
    }
  };

  const slideVariants: Variants = {
    hidden: { 
      opacity: 0,
      x: -50
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8
      }
    }
  };

  const scaleVariants: Variants = {
    hidden: { 
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.7
      }
    }
  };

  // Create variants for upward movement animation
  const upVariants: Variants = {
    hidden: { 
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  // Create variants for upward movement from below
  const upFromBelowVariants: Variants = {
    hidden: { 
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  // Create variants for downward movement from above (desktop marquee)
  const downFromAboveVariants: Variants = {
    hidden: { 
      opacity: 0,
      y: -50
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  // Create separate variants for logo sliding from left
  const logoVariants: Variants = {
    hidden: { 
      opacity: 0,
      x: -100
    },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  // Create variants for nav container without vertical movement
  const navContainerVariants: Variants = {
    hidden: { 
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1
      }
    }
  };

  // Create variants for nav links sliding from right
  const navLinkVariants: Variants = {
    hidden: { 
      opacity: 0,
      x: 100,
      y: 0
    },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  // Create separate container variants for bottom content with delay
  const bottomContainerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.15,
        delayChildren: 0.8
      }
    }
  };

  const buttonVariants: Variants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.7
      }
    }
  };

  return (
    <motion.div 
      className="black-section"
    >
      <motion.header className="header" variants={slideVariants} initial="hidden" whileInView="visible" viewport={{ once: false, amount: 0.1 }}>
        <motion.div className="logo" variants={logoVariants}>
          <motion.span 
            className="logo-symbol" 
            variants={scaleVariants}
            whileHover={{ rotate: 180, transition: { duration: 0.6 } }}
          >
            Z
          </motion.span>
          <motion.span className="logo-text">
            STUDIO Z26
          </motion.span>
        </motion.div>
        <motion.nav className="navigation" variants={navContainerVariants}>
          <motion.a href="#home" className="nav-link" variants={navLinkVariants} whileHover={{ scale: 1.1 }}>
            HOME
          </motion.a>
          <motion.a href="#about" className="nav-link" variants={navLinkVariants} whileHover={{ scale: 1.1 }} onClick={(e) => { e.preventDefault(); scrollToWhiteSection(); }}>
            ABOUT
          </motion.a>
          <motion.a href="#contact" className="nav-link" variants={navLinkVariants} whileHover={{ scale: 1.1 }} onClick={(e) => { e.preventDefault(); scrollToContact(); }}>
            CONTACT
          </motion.a>
        </motion.nav>
      </motion.header>
      
      <motion.main className="main-content" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{ once: false, amount: 0.1 }}>
        <motion.div className="portfolio-text" variants={upVariants}>
          STUDIO Z26
        </motion.div>
        <motion.div className="image-container" variants={upVariants}>
          <motion.img 
            src="https://res.cloudinary.com/dhqmcmekn/image/upload/v1783043405/12x18_02_noxcnc.webp" 
            alt="Woman portrait" 
            className="portrait-image"
          />
          <motion.div className="image-overlay-text" variants={upVariants}>
            GRACE<br/>STYLE
          </motion.div>
        </motion.div>
        
        <motion.div className="marquee-section desktop-marquee" variants={downFromAboveVariants}>
          <motion.div className="marquee-content">
            <motion.span className="marquee-text" variants={downFromAboveVariants}>
              WEDDING FILMS • PRE-WEDDING STORIES • ENGAGEMENT CINEMA • PROPOSAL CAPTURE • CEREMONY COVERAGE • RECEPTION HIGHLIGHTS • COUPLE INTERVIEWS • FAMILY MOMENTS • AERIAL DRONE FOOTAGE • SLOW MOTION CINEMATOGRAPHY • 4K ULTRA HD • PROFESSIONAL COLOR GRADING • CUSTOM MUSIC EDITING • SAME DAY HIGHLIGHTS • FEATURE FILMS • SOCIAL MEDIA CLIPS •
            </motion.span>
            <motion.span className="marquee-text" variants={downFromAboveVariants}>
              WEDDING FILMS • PRE-WEDDING STORIES • ENGAGEMENT CINEMA • PROPOSAL CAPTURE • CEREMONY COVERAGE • RECEPTION HIGHLIGHTS • COUPLE INTERVIEWS • FAMILY MOMENTS • AERIAL DRONE FOOTAGE • SLOW MOTION CINEMATOGRAPHY • 4K ULTRA HD • PROFESSIONAL COLOR GRADING • CUSTOM MUSIC EDITING • SAME DAY HIGHLIGHTS • FEATURE FILMS • SOCIAL MEDIA CLIPS •
            </motion.span>
          </motion.div>
        </motion.div>
        
        <motion.div className="marquee-section mobile-marquee" variants={upFromBelowVariants}>
          <motion.div className="marquee-content">
            <motion.span className="marquee-text" variants={upFromBelowVariants}>
              WEDDING FILMS • PRE-WEDDING STORIES • ENGAGEMENT CINEMA • PROPOSAL CAPTURE • CEREMONY COVERAGE • RECEPTION HIGHLIGHTS • COUPLE INTERVIEWS • FAMILY MOMENTS • AERIAL DRONE FOOTAGE • SLOW MOTION CINEMATOGRAPHY • 4K ULTRA HD • PROFESSIONAL COLOR GRADING • CUSTOM MUSIC EDITING • SAME DAY HIGHLIGHTS • FEATURE FILMS • SOCIAL MEDIA CLIPS •
            </motion.span>
            <motion.span className="marquee-text" variants={upFromBelowVariants}>
              WEDDING FILMS • PRE-WEDDING STORIES • ENGAGEMENT CINEMA • PROPOSAL CAPTURE • CEREMONY COVERAGE • RECEPTION HIGHLIGHTS • COUPLE INTERVIEWS • FAMILY MOMENTS • AERIAL DRONE FOOTAGE • SLOW MOTION CINEMATOGRAPHY • 4K ULTRA HD • PROFESSIONAL COLOR GRADING • CUSTOM MUSIC EDITING • SAME DAY HIGHLIGHTS • FEATURE FILMS • SOCIAL MEDIA CLIPS •
            </motion.span>
          </motion.div>
        </motion.div>
      </motion.main>
      
      <motion.div className="bottom-content" variants={bottomContainerVariants} initial="hidden" whileInView="visible" viewport={{ once: false, amount: 0.1 }}>
        <motion.div className="left-content" variants={upFromBelowVariants}>
          <motion.p className="welcome-text" variants={upFromBelowVariants}>
            <i>WELCOME TO</i><br/><b>OUR PORTFOLIO</b>
          </motion.p>
        </motion.div>
        <motion.div className="right-content" variants={upFromBelowVariants}>
          <motion.button
            className="gallery-button"
            variants={buttonVariants}
            onClick={scrollToPortfolio}
          >
            <span>CHECK OUT<br/>THE GALLERY</span>
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default BlackSection;
